export class FormatNumbers {
  static formatBytes = (bytes: number, decimals = 1): string => {
    if (!bytes) return 'N/A';
    const gb = bytes / 1024 ** 3;
    if (gb >= 1) return `${gb.toFixed(decimals)} GB`;
    return `${(bytes / 1024 ** 2).toFixed(decimals)} MB`;
  };
}
